export const onDialogEditDoneProp = property => ({
  widget: 'models',
  type: 'onDialogEditDoneProp',
  payload: { property },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogEditDoneProp.js